<template>
    <div class="d-flex flex-column h-100 container">
        <loading ref="loading"></loading>
        <local-error v-bind:inline='[]'></local-error>
        <template v-if='stage == 1'>
            <template v-if='hasAvailableSessions'>
                <div class="card text-center card--booking mb-3">
                    <div class="pt-3 pb-2">
                        <p v-if='$root.lookup.appointment_types && item.appointment_type_id'>
                            {{translateLookupItem($root.lookup.appointment_types, item.appointment_type_id)}}<br>
                            {{this.$t("translations.choose_appointment_day")}}
                        </p>
                    </div>
                </div>
                <div class="flex-grow-1-scroll">
                    <b-form-radio-group
                                buttons
                                stacked
                                v-model="session"
                                class='btn-block'
                                button-variant="card-radio"
                                name="date">
                        <b-form-radio v-if='session.length' :value='date' :key='date' v-for='(session, date) in sessions'>{{moment(date).format('LL')}}</b-form-radio>
                    </b-form-radio-group>
                    
                </div>
            </template>
            <template v-else>
                <div class="card text-center card--booking">
                    <div class="pt-3 pb-2">
                        <p>
                            {{this.$t("translations.no_sessions_available")}}
                        </p>
                    </div>
                </div>
            </template>
            <div class="mt-auto d-flex p-2 container">
                <span class="btn btn-warning btn-round" v-on:click='$router.push({path: "/profile"});'>Cancel</span>
                <!-- disabled if no time day -->
                <button class="btn btn-secondary btn-round ml-auto" :disabled='!session' v-on:click='stage++'>Confirm Day</button>
            </div>
        </template>


        <!-- -->
        <template v-if='stage == 2'>
            <template v-if='hasAvailableSessionTimes'>
                <div class="card text-center card--booking">
                    <div class="pt-3 pb-2">
                        <p>
                            {{this.$t("translations.choose_appointment_time")}}
                        </p>
                    </div>
                </div>
                <div class="flex-grow-1-scroll">
                    <b-form-radio-group
                                buttons
                                stacked
                                v-model="appointment"
                                class='btn-block'
                                button-variant="primary-outline"
                                name="date">
                        <b-form-radio 
                            :disabled='!appointment.available' 
                            v-bind:style='appointment.current ? {"backgroundColor": "pink"} : {}' 
                            :value='appointment' 
                            :key='appointment.from' 
                            v-for='appointment in sortByValue(sessions[session], "start_at")'>{{moment(appointment.from).format('HH:mm')}}</b-form-radio>
                    </b-form-radio-group>
                    <!-- <span class="btn btn-tertiary btn-round btn-block">08:00am</span> -->
                </div>
            </template>
            <template v-else>
                <div class="card text-center card--booking">
                    <div class="pt-3 pb-2">
                        <p>
                            {{this.$t("translations.no_appointments_available")}}
                        </p>
                    </div>
                </div>
            </template>
            <div class="mt-auto d-flex p-2 container">
                <span class="btn btn-warning btn-round" v-on:click='stage--; appointment = null; session = null'>Back</span>
                <!-- disabled if no time selected -->
                <button class="btn btn-secondary btn-round ml-auto" :disabled='!appointment' v-on:click='stage++'>Confirm Time</button>
            </div>
        </template>


        <!-- -->
        <template v-if='stage == 3'>
            <div class="card text-center card--booking">
                <div class="pt-3 pb-2">
                    <p v-if='$root.lookup.appointment_types && item.appointment_type_id'>
                        Please confirm your <strong>{{this.translateLookupItem($root.lookup.appointment_types, item.appointment_type_id)}}</strong> appointment with
                    </p>
                    <div class="featured-content">
                        <p>{{formatClinician(getAppointmentSessionTypeUser(item))}}<br>
                            {{moment(appointment.from).format('LLLL')}}<br>
                            <template v-if='appointment.site_id'> at {{appointment.site.name}}</template>
                        </p>
                    </div>
                </div>
            </div>
            
            <div class="mt-auto d-flex p-2 container">
                <span class="btn btn-warning btn-round" v-on:click='stage--;'>Back</span>
                <!-- disabled if no time selected -->
                <button class="btn btn-primary btn-round ml-auto" v-on:click='bookAppointment()'>Confirm appointment</button>            </div>
        </template>

    </div>
</template>

<script>
    export default {
        props: [

        ],
        data: function(){
            return {
                item: {
                    "id":null,
                    "thread_id":null,
                    "appointment_session_type_id":null,
                    "appointment_session_id":null,
                    "appointment_type_id":null,
                    "site_id":null,
                    "length":null,
                    "start_at":null,
                    "end_at":null
                },
                stage: 1,
                sessions: [],
                session: null,
                appointment: null,
                errors: []
            };
        },
        mounted() {
            this.item.id = this.$route.params["id"];
            this.getAppointment();

        },
        computed: {
            hasAvailableSessions() {
                console.info(this.sessions);
                if(this.sessions && Object.keys(this.sessions).length) {
                    console.info("HERE");
                    return Object.keys(this.sessions).filter(key => {
                        return this.sessions[key].length > 0;
                    }).length > 0;
                }
                return false;
            },
            hasAvailableSessionTimes() {
                if(this.session && this.sessions[this.session].length) {
                    return true;
                }
                return false;
            }
        },
        watch: {

        },
        methods: {
            getAppointment(id) {
                this.setLoading(true);

                axios.get(this.$root.apiBase + '/appointments/' + this.item.id).then((res) => {
                    this.item = res.data["appointment"];
                    this.getAppointmentSessions();
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/profile"});
                });
            },
            getAppointmentSessions() {
                axios.get(this.$root.apiBase 
                        + '/appointment_sessions/getSessionsForAppointment/' + this.item.id).then((res) => {
					this.setLoading(false);
					this.sessions = this.sortByKey(res.data["appointment_sessions"]);
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/profile"});
                });
            },
            bookAppointment() {
                this.item.appointment_session_type_id = this.appointment.appointment_session_type.id;
                this.item.start_at = this.appointment.from;
                this.setLoading(true);

                axios.post(this.$root.apiBase + '/appointments/' + this.item.id, this.item).then((res) => {
                    this.setLoading(false);
                    this.item = res.data["appointment"];
                    this.$router.push({path: "/profile"});
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                });
            },
        }
    }

</script>
